export const studio = {
  name: "V8Studio",
  email: "vilmir-98@mail.ru",
  telegram: "https://t.me/Gehidi777",
  telegramLabel: "Написать в Telegram",
  emailLabel: "Написать на почту",
  kwork: "https://kwork.ru/user/vilmir17",
  kworkLabel: "Отзывы на Kwork",
  kworkContactLabel: "Написать на Kwork",
}

export const highlights = [
  {
    title: "От 2х дней",
    text: "Короткий дизайн и небольшой бот можно запустить без долгого прогрева команды.",
  },
  {
    title: "Отчёт каждый день",
    text: "В конце рабочего дня видно, что сделано, что в работе и где нужно ваше решение.",
  },
  {
    title: "Гарантия 2 месяца",
    text: "После сдачи исправляем ошибки в функционале, который разработала наша команда.",
  },
  {
    title: "Правки по ходу",
    text: "Состав работ можно менять на проекте: сразу показываем, как это влияет на срок и бюджет.",
  },
] as const

export const cases = [

  {
    id: "pulse",
    title: "Telegram бот Pulse",
    summary: "Бот записи: клиент выбирает окно, администратор видит загрузку дня без таблиц.",
    tag: "Бот",
  },
  {
    id: "lumen",
    title: "Lumen",
    summary: "Сервис подписок: тарифы, оплаты и кабинет клиента без лишних шагов.",
    tag: "Веб-сервис",
  },
  {
    id: "forge",
    title: "Forge",
    summary: "Панель студии: задачи, часы и статусы проектов для небольшой команды.",
    tag: "Внутренний сервис",
  },
] as const

export type CaseId = (typeof cases)[number]["id"]

export const approach = {
  title: "Думаем о вашем бизнесе как о своём",
  points: [
    {
      number: "01",
      title: "Сначала разбираем процесс",
      text: "Смотрим не только бриф, а то, как у вас приходят заявки, где люди делают одно и то же руками и что должно заработать в первой версии.",
    },
    {
      number: "02",
      title: "Предлагаем следующий шаг",
      text: "По ходу работы говорим, что усилит продукт: убрать экран, связать сервис с тем, чем вы уже пользуетесь, или отложить лишнее на потом.",
    },
    {
      number: "03",
      title: "Запускаем то, что можно проверить",
      text: "Срок и состав работ видны заранее. В прод уходит сценарий, которым уже можно пользоваться, а не набор экранов «на вырост».",
    },
  ],
}

export const services = [
  {
    id: "web",
    title: "Веб-приложения",
    description:
      "Кабинеты, сервисы и внутренние панели, которые выдерживают рост и остаются понятными для команды.",
    term: "от 3 дней",
    price: "от 4000 ₽",
  },
  {
    id: "bots",
    title: "Боты (Telegram, VK, OK)",
    description:
      "Сценарии в мессенджерах: запись, заявки, статусы заказов и ответы, которые не требуют живого оператора на каждый вопрос.",
    term: "от 2 дней",
    price: "от 3000 ₽",
  },
  {
    id: "design",
    title: "Консультация",
    description:
      "Консультация по разработке веб-приложения или бота - стек технологий, архитектурные решения, подходы к разработке, etc.",
    term: "от 15 минут",
    price: "от 800 ₽",
  },

] as const

export const stackGroups = [
  {
    title: "Frontend",
    items: ["TypeScript", "React", "Next.js", "React Native"],
  },
  {
    title: "Backend",
    items: ["Node.js", "PostgreSQL", "Prisma", "FastAPI"],
  },
  {
    title: "UX/UI",
    items: ["Figma", "Прототипы", "Дизайн-системы", "Анимация интерфейса"],
  },
] as const

export const about = {
  title: "О студии",
  text: "V8Studio проектирует и разрабатывает цифровые продукты для компаний, которым тесно в конструкторах. На проекте один менеджер ведёт переписку, а команда показывает промежуточный результат, а не только финальную сдачу.",
  principles: [
    {
      title: "Гибкость",
      text: "Подстраиваем план под изменения в задаче и фиксируем, что именно меняется в сроке и составе работ.",
    },
    {
      title: "Гарантия",
      text: "Два месяца после запуска закрываем ошибки в функционале, который сделали мы.",
    },
    {
      title: "Результат",
      text: "Ориентир — сценарий, которым пользуются, а не объём экранов в макете.",
    },

  ],
}

export const processSteps = [
  {
    number: "01",
    title: "Анализ",
    text: "Разбираем, как устроена работа сейчас и какой результат первой версии будет заметен.",
  },
  {
    number: "02",
    title: "Проектирование",
    text: "Собираем сценарий, прототип и границы релиза. Согласуем их до разработки.",
  },
  {
    number: "03",
    title: "Разработка",
    text: "Идём короткими отрезками. На каждом видно работающий кусок, а не только статус в таблице.",
  },
  {
    number: "04",
    title: "Запуск",
    text: "Проверяем основные сценарии, подключаем данные и выпускаем, когда продуктом уже можно пользоваться.",
  },
  {
    number: "05",
    title: "Поддержка",
    text: "После запуска остаёмся на связи: чиним сданное и помогаем наращивать следующую версию.",
  },
] as const

export const pricingModels = [
  {
    id: "time",
    title: "Time & Material",
    subtitle: "Оплата по факту",
    points: [
      {
        label: "Оплата за работу",
        text: "Бюджет складывается из часов и задач, которые реально сделали.",
      },
      {
        label: "Гибкий состав",
        text: "Приоритеты можно менять на любом этапе, не пересобирая весь договор.",
      },
      {
        label: "Прозрачный ход",
        text: "Видно, куда ушло время, и можно остановить или усилить направление.",
      },
    ],
  },
  {
    id: "fixed",
    title: "Fix price",
    subtitle: "Фиксированная цена",
    points: [
      {
        label: "Бюджет на старте",
        text: "Стоимость согласована до разработки и не растёт внутри оговорённого объёма.",
      },
      {
        label: "Понятный срок",
        text: "Дата запуска привязана к составу работ, а не к открытому списку пожеланий.",
      },
      {
        label: "Для ясной задачи",
        text: "Подходит, когда сценарий и границы первой версии уже можно описать.",
      },
    ],
  },
] as const

export const reviews = [

  {
    id: "ilya",
    name: "Илья Петров",
    role: "Основатель, Pulse",
    text: "Бот записи забрал у администраторов рутину уже на первой неделе. По пути нам предложили убрать два лишних шага — и запись стала короче, чем мы сами набросали.",
  },
  {
    id: "elena",
    name: "Елена Крылова",
    role: "Руководитель продукта, Lumen",
    text: "На каждом отрезке было понятно, что уже можно потрогать. Не пришлось ждать «большого релиза», чтобы увидеть, как клиент проходит оплату.",
  },
  {
    id: "artem",
    name: "Артём Белов",
    role: "Руководитель, Forge",
    text: "Панель для своих проектов собрали быстрее, чем мы закладывали. Отчёт приходил каждый день, и ни одно решение не зависало в переписке.",
  },
  {
    id: "kirill",
    name: "Кирилл Новиков",
    role: "Маркетинг, Harbor",
    text: "Пришли с размытой задачей и ограниченным бюджетом. Нам собрали первую версию вокруг одного сценария, а остальное честно отложили. Запуск не расползся.",
  },
] as const

export const posts = [
  {
    id: "landing-or-cabinet",
    date: "18.02.2026",
    title: "Лендинг или личный кабинет: как выбрать первую версию",
    excerpt:
      "Когда достаточно страницы с заявкой, а когда без кабинета сотрудники снова уйдут в таблицы.",
  },
  {
    id: "bot-estimate",
    date: "04.03.2026",
    title: "Оценка бота до старта: что выяснить у заказчика",
    excerpt:
      "Пять вопросов про исключения, интеграции и живых операторов, без которых смета будет гаданием.",
  },
  {
    id: "mobile-scope",
    date: "21.03.2026",
    title: "Первая версия мобильного приложения без лишних экранов",
    excerpt:
      "Как оставить в релизе один рабочий сценарий и не тащить в него весь будущий продукт.",
  },
  {
    id: "design-handoff",
    date: "09.04.2026",
    title: "Макет, который разработчик собирает без догадок",
    excerpt:
      "Состояния, пустые экраны и ошибки, которые нужно нарисовать до того, как откроется задача.",
  },
] as const

export const faq = [
  {
    id: "control",
    question: "Можно ли следить за ходом работ?",
    answer:
      "Да. Задачи лежат на общей доске, а в конце рабочего дня приходит короткий отчёт: что сделано и что дальше.",
  },
  {
    id: "spec",
    question: "Нужно ли готовое техническое задание?",
    answer:
      "Нет. Если описание уже есть, работаем по нему. Если нет, на старте вместе фиксируем сценарии и границы первой версии.",
  },
  {
    id: "support",
    question: "Что входит в поддержку после запуска?",
    answer:
      "Два месяца исправляем ошибки в сданном функционале. Дальше можно взять пакет часов, если продукт нужно развивать.",
  },
  {
    id: "price",
    question: "От чего зависит стоимость?",
    answer:
      "От числа сценариев, интеграций и того, нужен ли дизайн с нуля. После короткого разбора называем оценку по этапам, а не одну цифру «в среднем по рынку».",
  },
  {
    id: "changes",
    question: "Можно ли менять требования в процессе?",
    answer:
      "Да. Новую задачу оцениваем отдельно и согласуем, как она сдвигает срок и бюджет, до того как брать её в работу.",
  },

  {
    id: "budget",
    question: "Что если бюджет ограничен?",
    answer:
      "Собираем первую версию вокруг самого нужного сценария и откладываем остальное. В том, что запускаем, качество не урезаем.",
  },
] as const
